import React from 'react'

const MwButton = (props) => {
    const {
            actionType,
            onClick,
            children,
            type,
            size,
            classNameCustom,
            className,
            inGroup = false,
            disabled = false,
        } = props

        const baseSize = size === 'sm' ? 'h-7 px-3' : 'h-9 px-4';
        let classItem = `finance-btn flex items-center justify-center gap-1 text-xs font-semibold rounded-md border transition-colors duration-150 ${baseSize} ${classNameCustom || className || ''} `;

        switch(type) {
            case 'secondary':
            case 'secondary-inline-end':
            case 'middleBtn':
            case 'original-left':
            case 'original-right':
                classItem += ` finance-secondary-btn bg-white border-[#d7dce3] text-[#261759] hover:bg-[#f5f8f1] hover:border-[#b9d99a] ${disabled ? 'opacity-60 cursor-not-allowed' : ''} ${inGroup ? 'rounded-none first:rounded-s-md last:rounded-e-md' : ''}`
                break;
            case 'saveBtn':
            case 'addBtn':
            case 'bottomBtn':
            default:
                classItem += ` finance-primary-btn border-[#261759] bg-[#261759] text-white hover:bg-[#1f124c] hover:border-[#1f124c] ${disabled ? 'opacity-60 cursor-not-allowed' : ''} ${inGroup ? 'rounded-none first:rounded-s-md last:rounded-e-md' : ''}`
                break;
            case 'deleteBtn':
            case 'deleteBtn-inline':
            case 'circular-right':
                classItem += ` finance-danger-btn border-[#dc2626] bg-white text-[#dc2626] hover:bg-[#fef2f2] hover:text-[#991b1b] hover:border-[#991b1b] ${disabled ? 'opacity-60 cursor-not-allowed' : ''} ${inGroup ? 'rounded-none first:rounded-s-md last:rounded-e-md' : ''}`
                break;
            case 'cancelBtn':
                classItem += ` finance-cancel-btn border-[#d7dce3] bg-white text-[#261759] hover:bg-[#f5f8f1] hover:border-[#b9d99a] ${disabled ? 'opacity-60 cursor-not-allowed' : ''} ${inGroup ? 'rounded-none first:rounded-s-md last:rounded-e-md' : ''}`
                break;
            case 'circular-left':
            case 'circular-back':
                classItem += ` finance-primary-btn border-[#261759] bg-[#261759] text-white hover:bg-[#1f124c] hover:border-[#1f124c] ${disabled ? 'opacity-60 cursor-not-allowed' : ''} ${inGroup ? 'rounded-full' : ''}`
                break;
        }
    return (
        <button
            type={actionType}
            onClick={onClick} 
            disabled = {disabled}
            className={classItem}>
            {children}
        </button>
    )
}

export default MwButton

